import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminUpdatePassword } from '../api';

export default function ConfiguracoesScreen() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('authToken');

  // Estados para troca de senha (hooks devem vir antes de qualquer return condicional)
  const [pwdOld, setPwdOld] = useState('');
  const [pwdNew, setPwdNew] = useState('');
  const [pwdConfirm, setPwdConfirm] = useState('');
  const [pwdStatus, setPwdStatus] = useState({ loading: false, error: '', success: '' });

  // Redireciona se não estiver logado
  if (!token) {
    navigate('/acesso-profissional');
    return null;
  }

  const handleChangePassword = async () => {
    setPwdStatus({ loading: true, error: '', success: '' });
    if (pwdNew !== pwdConfirm) {
      setPwdStatus({ loading: false, error: 'A nova senha e a confirmação não coincidem.', success: '' });
      return;
    }
    if (pwdNew.length < 6) {
      setPwdStatus({ loading: false, error: 'A nova senha deve ter pelo menos 6 caracteres.', success: '' });
      return;
    }
    try {
      const res = await adminUpdatePassword(pwdOld, pwdNew);
      setPwdStatus({ loading: false, error: '', success: res.message || 'Senha alterada com sucesso!' });
      setPwdOld('');
      setPwdNew('');
      setPwdConfirm('');
    } catch(e: any) {
      setPwdStatus({ loading: false, error: e?.response?.data?.error || 'Erro ao alterar senha.', success: '' });
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: '0 auto', paddingTop: 32 }}>
      <div style={{ textAlign: 'center', marginBottom: 18 }}>
        <img src="/assets/icones-curriculo-06.svg" alt="Ícone Configurações" style={{ width: '48px', height: '48px' }} />
      </div>
      <h2 style={{ color: 'var(--primary-color)', fontWeight: 700, fontSize: 22, marginBottom: 8, textAlign: 'center' }}>
        Configurações
      </h2>
      <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: 14, marginBottom: 24 }}>
        Gerencie as configurações da sua conta.
      </p>

      <div style={{ padding: 20, backgroundColor: '#f8f9fa', borderRadius: 12 }}>
        <h4 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>Alterar Senha de Acesso</h4>
        
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label>Senha Atual</label>
          <input 
            type="password" 
            value={pwdOld} 
            onChange={e => setPwdOld(e.target.value)} 
            placeholder="Digite a senha atual"
          />
        </div>
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label>Nova Senha</label>
          <input 
            type="password" 
            value={pwdNew} 
            onChange={e => setPwdNew(e.target.value)} 
            placeholder="Digite a nova senha (mínimo 6 caracteres)"
          />
        </div>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label>Confirmar Nova Senha</label>
          <input 
            type="password" 
            value={pwdConfirm} 
            onChange={e => setPwdConfirm(e.target.value)} 
            placeholder="Repita a nova senha"
            onKeyDown={(e) => e.key === 'Enter' && handleChangePassword()}
          />
        </div>

        {pwdStatus.error && <div style={{ color: 'red', marginBottom: 12, fontSize: 14 }}>{pwdStatus.error}</div>}
        {pwdStatus.success && <div style={{ color: 'green', marginBottom: 12, fontSize: 14, padding: '10px', backgroundColor: '#e8f5e9', borderRadius: '8px' }}>{pwdStatus.success}</div>}

        <button 
          className="btn btn-primary" 
          disabled={pwdStatus.loading || !pwdOld || !pwdNew || !pwdConfirm}
          onClick={handleChangePassword}
          style={{ padding: '10px 20px', width: '100%' }}
        >
          {pwdStatus.loading ? 'Alterando...' : 'Salvar Nova Senha'}
        </button>
      </div>

      <div style={{ marginTop: 24, textAlign: 'center' }}>
        <button className="btn btn-outline" style={{ fontSize: 14, padding: '8px 20px' }} onClick={() => navigate('/acesso-profissional')}> 
          Voltar ao Painel
        </button>
      </div>
    </div>
  );
}
